import { TestQuotationLine } from './test-quotation-line.model';
import { PackageQuotationLine } from './package-quotation-line.model';

export class CustomerPackage {
    comlimsCode?: string;
    price?: number;
    code?: string;
    name?: string;
    comment?: string;
    sortIndex?: number;
    testQuotationLines?: TestQuotationLine[];
    packageQuotationLines?: PackageQuotationLine[];
    isFavorite?: boolean;
    isSelected?: boolean;
    hideItem = false;
    executionNumber?:number;
}
